import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaSelector } from '../ma-pojo/market-analysis-classes';
import { fadeInOutAnimation } from '../../../../../util/animations/fade-in-out.animation';
import { LocalDate } from '../../../../pojo/date-variable';

@Component({
  selector: 'app-ma-selector',
  templateUrl: './ma-selector.component.html',
  styleUrls: ['./ma-selector.component.scss'],
  animations: [fadeInOutAnimation(200, 0)],
})
export class MaSelectorComponent {
  @Input() title: string;
  @Input() selectedPeriod: LocalDate;
  @Input() periods: LocalDate[];
  @Input() selectorType: MaSelector;

  @Output() selectPeriod: EventEmitter<{ period: LocalDate; selectorType: MaSelector }> = new EventEmitter();

  showPicker = false;

  onPeriodSelect(period: LocalDate): void {
    this.selectPeriod.emit({ period, selectorType: this.selectorType });
  }
}
